import styled from "styled-components";

export const Container = styled.div`
  background: white;
  border-radius: 20px;
  overflow: hidden;
`;

export const ContentSection = styled.div`
  padding: 20px 16px 20px 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media screen and (min-width: 768px) {
    flex-direction: row;
    padding: 100px;
  }
  //first div
  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  /* Select the second image */
  img:nth-of-type(2) {
    object-fit: cover;
    width: 100%;
    margin: 12px 0 12px;
  }
  .handwithmobile {
    width: 100%;
    margin: 0 auto;
    box-shadow: 0px 2px 5px #0000001a;
    overflow: hidden;
    border-radius: 20px;
    @media screen and (min-width: 768px) {
      width: 318px;
      height: 568px;
    }
  }
`;

export const Title = styled.h3`
  color: #142c1f;
  margin: 12px auto;
  font-size: 16px;
  text-align: center;
  @media screen and (min-width: 768px) {
    font-size: 22px;
  }
`;
